import {
  IconMoodAngry,
  IconMoodEmpty,
  IconMoodHappy,
  IconMoodSad,
  IconMoodSmileBeam,
} from "@tabler/icons-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"

type Props = {
  sentiment: number
  className?: string
  size?: number
  showTooltip?: boolean
}

const sentimentMap = [
  {
    threshold: 3.3,
    icon: IconMoodHappy,
    labelKey: "veryPositive",
    className: "text-positive",
  },
  {
    threshold: 2.3,
    icon: IconMoodSmileBeam,
    labelKey: "positive",
    className: "text-positive-soft",
  },
  {
    threshold: 1.7,
    icon: IconMoodEmpty,
    labelKey: "neutral",
    className: "text-neutral",
  },
  {
    threshold: 0.7,
    icon: IconMoodSad,
    labelKey: "negative",
    className: "text-negative-soft",
  },
  {
    threshold: -Infinity,
    icon: IconMoodAngry,
    labelKey: "veryNegative",
    className: "text-negative",
  },
]

export const SentimentIcon = ({ sentiment, className, size = 20, showTooltip = false }: Props) => {
  const { t } = useTranslation()

  const {
    icon: Icon,
    labelKey,
    className: iconClass,
  } = sentimentMap.find(({ threshold }) => sentiment >= threshold)!

  const iconElement = (
    <Icon
      aria-label={t(`shared.sentiments.${labelKey}`)}
      className={cn(iconClass, className)}
      size={size}
    />
  )

  if (!showTooltip) return iconElement

  return (
    <Tooltip>
      <TooltipTrigger asChild>{iconElement}</TooltipTrigger>
      <TooltipContent>{t(`shared.sentiments.${labelKey}`)}</TooltipContent>
    </Tooltip>
  )
}
